import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "rhl:favorites";

function readFavorites(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === "string") : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const isFavorite = useCallback(
    (id: string) => favorites.includes(id),
    [favorites],
  );

  const toggleFavorite = useCallback((id: string) => {
    const next = readFavorites().includes(id)
      ? readFavorites().filter((item) => item !== id)
      : [...readFavorites(), id];
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setFavorites(next);
    return next.includes(id);
  }, []);

  return { favorites, isFavorite, toggleFavorite };
}